// 地図設定
export const StyleURL = "mapple01/style_mapple1_localfont.json";
export const StyleURL_Gray = "mapple01/style_mapple1_localfont_gray.json";
export const bizyoffset = -0.08;
export const BizFontName = "Noto Sans JP Regular";
export const BizFontNameNINI = "Noto Sans JP Medium";
export const F_Hude_fill_opacity = 0.2;

// 筆ポリゴンの配色（メイン地図の MapLibre と NiniMap モーダルの Leaflet で共用）
// 任意座標は公共座標の赤（#FF0000＝HSL 0,100%,50%）と明度・彩度を揃えたオレンジ
export const HUDE_COLORS = {
  nini_fill: "#FF8000", // 任意座標の面（未購入）
  nini_line: "#FF8000", // 任意座標の線
  purchased_fill: "#0000ff", // 購入済みの面（公共・任意共通）
};

// 属性テーブルに表示せず、地番ポリゴンDLの出力にも含めないプロパティ
export const EXCLUDED_PROPERTY_KEYS = [
  "代表点緯度",
  "代表点経度",
  "分割番号",
  "種別",
];

// 著作権表記
export const mojcopyright =
  '<a href="https://front.geospatial.jp/" target="_blank" rel="noopener noreferrer">登記所備付地図データ（法務省）</a>';
export const mojcopyright_leaflet =
  '<a href="https://front.geospatial.jp/" target="_blank" rel="noopener noreferrer">登記所備付地図<br>データ（法務省）</a>';

// 非表示リスト
export const Arr_NoDispMap = await fetch(process.env.REACT_APP_NO_DISP_MAP)
  .then((response) => response.text())
  .then((data) => {
    //非表示の図面を配列に入れる
    return data.split(/\r\n/);
  });

// 非表示リスト（任意座標） 取得失敗時は空配列
// 書式: 「{ファイル名},{分割番号}」（分割ブロック単位）または「{ファイル名}」（ファイル全体）
const nini_nodisp_lines = await fetch(process.env.REACT_APP_NO_DISP_NINI)
  .then((response) => response.text())
  .then((data) =>
    //非表示の任意座標図面を配列に入れる（空行・前後空白は除去）
    data
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line)
  )
  .catch(() => []);
// ファイル全体の非表示（カンマなしの行）
export const Arr_NoDispNiniFiles = nini_nodisp_lines.filter(
  (line) => !line.includes(",")
);
// 分割ブロック単位の非表示（「ファイル名,分割番号」の合成キーのまま保持）
export const Arr_NoDispNiniBlocks = nini_nodisp_lines.filter((line) =>
  line.includes(",")
);

// 目標物地名駅名検索
export const POISERVERNAME = process.env.REACT_APP_POI_SERVER_NAME;
export const POIPLUSAPP = process.env.REACT_APP_POI_PLUS_APP;

// 地番検索
export const SEARCH_DATA = process.env.REACT_APP_SEARCH_DATA;

// 特商法表記
export const SPECIFIED_COMMERCIAL_TRANSACTION_LAW_PATH =
  "https://labs.mapple.com/mapple03/mojmap/SpecifiedCommercialTransactionLaw_20260318.html";

// 利用規約
export const TERMS_OF_VIEWER =
  "https://labs.mapple.com/mapple03/mojmap/Riyoukiyaku_Viewer_20260318.html";
export const TERMS_OF_USE_PATH =
  "https://labs.mapple.com/mapple03/mojmap/Riyoukiyaku_Account_20260318.html";
export const LATEST_TERMS_UPDATE = await fetch(
  "https://labs.mapple.com/mapple03/termsUpdate.json"
)
  .then((response) => response.json())
  .then((data) => data.latestUpdate || "2000/01/01 00:00:00")
  .catch(() => "2000/01/01 00:00:00");

// mapple.comなど外部のページ
export const MAPPLE_COM_LINKS = {
  // mapple.com内の製品ページ
  PRODUCT_SITE: "https://biz.mapple.com/registrymap/",
  // mapple.com内のFAQページ
  FAQ_SITE: "https://biz.mapple.com/registrymap-faq/",
  //お問い合わせフォーム
  CONTACT_SITE: "https://biz.mapple.com/mapviewer-inq/",
  //アンケート
  SURVEY_SITE: "https://forms.gle/EQF8Xo6NUMhTg84VA",
  // サブスクリプションの詳細
  SUBSCRIPTION_NEWS: "https://labs.mapple.com/mapple03/mojmap/marual_mapple_subscription.pdf",
  // 登記情報（土地）の購入について
  REGISTRY_NEWS: "https://labs.mapple.com/mapple03/mojmap/marual_mapple_registry.pdf",
};

// 「MAPPLE法務局地図ビューア」についてモーダルの章キー（外部から特定章を開く用）
export const ABOUT_SECTION_NINI = "nini";

// 任意座標系重ね表示機能（β版）の注意書き
export const NINI_BETA_NOTICE = {
  TITLE: "【任意座標エリアの重ね表示（β版、2026/09/30公開）のご利用について】",
  SECTION_TITLE: "任意座標系重ね表示機能（β版）について",
  // Aboutモーダル冒頭に常時表示する項目
  ITEMS: [
    "本機能で公開する任意座標エリアの重ね表示は、自治体等の公開データを基に機械処理で自動位置補正を行った参考表示（β版）となります。",
    "重ね表示の対象自治体においても、データの整備状況等により重ね表示および地番情報の閲覧ができないエリアが存在します。",
    "位置精度は100%ではなく、実際の現地状況や公図と位置ずれが生じる場合があります。境界確定や権利関係等の重要判断におきましては、必ず法務局の公図・現況等をご確認ください。",
    "無料β版としての提供であり、個別図面の位置補正・修正・非表示のご要望には対応いたしかねます。あらかじめご了承ください。",
    "ログインしていない状態では、位置合わせした任意座標のエリア（オレンジ色で表示される範囲）のみが表示されます。地図上に重ねた地番の表示や、クリックによる属性の表示をご利用いただくには、アカウント登録（無料）の上、ログインしてください。",
  ],
  // 左スライダーの「i」アイコンのマウスオーバー用（ネイティブ title）
  HINT: "自動位置補正による参考表示（β版）です。クリックすると詳しい案内を表示します。",
  // 右スライダーの属性パネル用
  PANEL_TITLE: "【任意座標エリアの重ね表示（β版）】",
  ONE_LINER:
    "自動位置補正による参考表示（β版）です。位置ずれが生じる場合があります。重要な判断の際は必ず法務局の公図・現況等をご確認ください。",
  LINK_PREFIX: "詳しくは",
  LINK_TEXT: "こちら",
};

// 任意座標の位置合わせの参考とした地番図等の出典
// ライセンスごとにまとめ、自治体名「データ名」を「、」で区切って並べる
export const NINI_CHIBANZU_SOURCES = {
  TITLE: "【位置合わせの参考とした地番図等】",
  LICENSE_GROUPS: [
    {
      license: "CC BY 4.0",
      items: [
        {
          city: "京都市",
          data: "京都市固定資産税（土地）地番図データ",
          url: "https://data.city.kyoto.lg.jp/dataset/00677/",
          // データ固有の利用規約が定められている自治体は項目の直後に示す
          termsUrl: "https://data.city.kyoto.lg.jp/dataset/00677/",
        },
        {
          city: "加古川市",
          data: "加古川市地番参考図（土地家屋図）データ",
          url: "https://opendata-api-kakogawa.jp/ckan/dataset/landhouse",
          termsUrl: "https://opendata-api-kakogawa.jp/ckan/dataset/landhouse",
        },
        {
          city: "市川市",
          data: "地籍図（地番図）",
          url: "https://www.city.ichikawa.lg.jp/page/4744.html",
        },
        {
          city: "町田市",
          data: "固定資産税（土地）地籍図",
          url: "https://www.city.machida.tokyo.jp/shisei/opendata/chizujoho/chisekizu.html",
        },
        {
          city: "名古屋市",
          data: "【名古屋市】地番参考図",
          url: "https://data.bodik.jp/dataset/231002_0703030000_chibansankouzu",
        },
        {
          city: "長岡京市",
          data: "地番参考図",
          url: "https://www.city.nagaokakyo.lg.jp/0000012991.html",
        },
        {
          city: "泉南市",
          data: "令和8年度泉南市地番参考図",
          url: "https://www.city.sennan.lg.jp/kakuka/soumu/zeimuka/kazeikakari/zeikin/koteishisan/1505179465186.html",
        },
      ],
    },
    {
      license: "CC BY 2.1 JP",
      items: [
        {
          city: "磐田市",
          data: "地番図",
          url: "https://www.city.iwata.shizuoka.jp/shiseijouhou/1006207/1002775.html",
        },
        {
          city: "奈良市",
          data: "地番図",
          url: "https://www.city.nara.lg.jp/soshiki/14/104605.html",
        },
      ],
    },
    {
      license: "PDL1.0",
      items: [
        {
          city: "宇都宮市",
          data: "地籍図データ（令和8年1月1日現在）",
          url: "https://catalog.city.utsunomiya.tochigi.jp/dataset/chibannzu-070101",
        },
        {
          // URL を画面に表示してリンクにする（データが埼玉県のポータル上にあるため所在を明示する）
          city: "越谷市財務部資産税課",
          data: "地番図データ(令和7年1月1日時点)",
          url: "https://opendata.pref.saitama.lg.jp/resources/7269",
          showUrl: true,
        },
        {
          city: "福山市",
          data: "福山市地番図データ（2026年度）",
          url: "https://data.city.fukuyama.hiroshima.jp/dataset/digital_numbers_map",
        },
      ],
    },
  ],
  TERMS_TEXT: "利用規約",
};

// Amplify 日本語化
// prettier-ignore
export const VOCABULARIES_JP = {
  "Sign In": "ログイン", // Tab header
  "Sign in": "ログイン", // Button label
  "Forgot your password?": "パスワードを忘れた場合",
  "Back to Sign In": "ログインに戻る",
  "or": "または",
  "User does not exist.": "ユーザーが存在しません",
  "Incorrect username or password.": "ユーザー名またはパスワードが違います",
  "User is not confirmed.": "ユーザーは検証されていません",
  "User already exists": "ユーザーは既に存在します",
  "Invalid verification code provided, please try again.":
    "指定された認証コードが無効です。もう一度お試しください",
  "Invalid password format": "パスワードのフォーマットが不正です",
  "Account recovery requires verified contact information":
    "アカウントの復旧には確認済みの連絡先情報が必要です",
  "Invalid phone number format":
    "不正な電話番号フォーマットです。 電話番号は次のフォーマットで入力してください: +12345678900",
  "An account with the given email already exists.":
    "そのメールアドレスは既に存在します",
  "Username cannot be empty": "ユーザー名は必須です",
  "Password attempts exceeded": "ログイン試行回数が上限に達しました",
  "Attempt limit exceeded, please try after some time.":
    "試行制限を超過しました。しばらくしてからもう一度お試しください",
  "Username/client id combination not found.": "ユーザーが存在しません",
  "CUSTOM_AUTH is not enabled for the client.": "パスワードは必須です", // 本来の意味とは異なるが、パスワード未入力時に発生するのでこの訳としている
  "Password does not conform to policy: Password not long enough":
    "パスワードは8文字以上を入力してください (8文字以上で大文字・小文字・数字を含む)", // 適宜修正
  "Password does not conform to policy: Password must have uppercase characters":
    "パスワードには大文字を含めてください (8文字以上で大文字・小文字・数字を含む)", // 適宜修正
  "Password does not conform to policy: Password must have lowercase characters":
    "パスワードには小文字を含めてください (8文字以上で大文字・小文字・数字を含む)", // 適宜修正
  "Password does not conform to policy: Password must have numeric characters":
    "パスワードには数字を含めてください (8文字以上で大文字・小文字・数字を含む)", // 適宜修正
  "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
    "パスワードは8文字以上、大文字・小文字・数字を含むように指定してください", // 適宜修正。本来の意味とは異なるがこれで明示している。
  "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\xA5S]+.*[\xA5S]+$":
    "パスワードは8文字以上、大文字・小文字・数字を含むように指定してください", // 適宜修正。本来の意味とは異なるがこれで明示している。
  "Temporary password has expired and must be reset by an administrator.":
    "一時パスワードは無効です。管理者によるリセットが必要です",
  "1 validation error detected: Value null at 'attributeName' failed to satisfy constraint: Member must not be null":
    "入力チェックエラー、必須項目がNULLです", //アカウント復旧でのメールアドレスのラジオをチェックONにせず、送信した場合
  "Invalid code received for user": "無効なコードです", // TOTPでのトークンに誤りがある
  "Invalid session for the user, session is expired.":
    "無効なセッション、セッションは有効期限切れです。ログインからやり直してください", // ログインセッション無効です、ログインからやり直し
  "Your passwords must match": "パスワードが一致していません",
  // パスワードリセット画面
  "Enter your email": "メールアドレスを入力",
  //パスワードリセット画面の次のコード入力＆新パスワード入力画面
  "Code *": "コード"
  //その他のメッセージ
  , "Network error": "ネットワークエラー"
  //その他のメッセージ　Cognitoの設定で、記号は含まなくてもよいようにはしているが、一応記載しておく
  , "Password did not conform with policy: Password must have lowercase characters": "パスワードには小文字を含めてください (8文字以上で大文字・小文字・数字を含む)"
  , "Password did not conform with policy: Password must have uppercase characters": "パスワードには大文字を含めてください (8文字以上で大文字・小文字・数字を含む)"
  , "Password did not conform with policy: Password must have numeric characters": "パスワードには数字を含めてください (8文字以上で大文字・小文字・数字を含む)"
  , "Password did not conform with policy: Password must have symbol characters": "パスワードには記号を含めてください (8文字以上で大文字・小文字・数字を含む)"
  , "Password did not conform with policy: Password not long enough": "パスワードは8文字以上にしてください (8文字以上で大文字・小文字・数字を含む)"
  , "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "パスワードは8文字以上で大文字・小文字・数字を含むようにしてください"
  //サインアップ画面
  , "TypeError": "入力不備があります"
}

// PDFサイズ
export const BASE_DPI = 96;
const MM_PER_INCHI = 25.4;
const PX_PER_MM = BASE_DPI / MM_PER_INCHI;
export const PDF_SIZE_MM = {
  A3: [420, 297],
  A4: [297, 210],
  B4: [353, 250],
  B5: [250, 176],
};
export const PDF_SIZE_PX = Object.keys(PDF_SIZE_MM).reduce((acc, key) => {
  acc[key] = [PDF_SIZE_MM[key][0] * PX_PER_MM, PDF_SIZE_MM[key][1] * PX_PER_MM];
  return acc;
}, {});
// 1ptあたりのpixcel数
export const PX_PER_PDF_PT = BASE_DPI / 72;
// 1mmあたりのpt数
export const PT_PER_MM = 72 / MM_PER_INCHI;
// ダウンロードファイル名
export const PDF_DOWNLOAD_FILE_NAME = "map.pdf";
// DPI選択肢
export const DPI_OPTIONS = [72, 96, 200, 300];

// Terradrawのデフォルト色設定
export const TERRADRAW_DEFAULT_COLORS = {
  point: {
    pointColor: "#3f97e0",
    pointWidth: 6,
    pointOutlineColor: "#ffffff",
    pointOutlineWidth: 2,
  },
  lineString: {
    lineStringColor: "#3f97e0",
    lineStringWidth: 4,
  },
  polygon: {
    fillColor: "#3f97e0",
    fillOpacity: 0.3,
    outlineColor: "#3f97e0",
    outlineWidth: 4,
  },
};
